import { render, staticRenderFns } from "./ButtonLabelSimple.vue?vue&type=template&id=8d358cb8&scoped=true"
import script from "./ButtonLabelSimple.vue?vue&type=script&lang=ts"
export * from "./ButtonLabelSimple.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d358cb8",
  null
  
)

export default component.exports